import { useContext, useEffect } from 'react';
import type { CarouselStoreInterface } from 'pure-react-carousel';
import { CarouselContext } from 'pure-react-carousel';

export const slideCarousel = (carouselContext: CarouselStoreInterface) => (e: KeyboardEvent) => {
  const {
    setStoreState,
    state: { currentSlide, totalSlides },
  } = carouselContext;
  if (e.code === 'ArrowRight' && currentSlide < totalSlides - 1) {
    setStoreState({ currentSlide: currentSlide + 1 });
  }

  if (e.code === 'ArrowLeft' && currentSlide > 0) {
    setStoreState({
      currentSlide: currentSlide - 1,
    });
  }
};

export function useMediaGalleryKeyboard(): void {
  const carouselContext = useContext(CarouselContext);
  const handler = (e: KeyboardEvent) => {
    const target = e.target as HTMLElement;
    // If focused on timeline tabs, Arrow right/left keys navigate between the tabs and shouldn't slide carousel
    if (!target?.className.includes('Tab')) {
      slideCarousel(carouselContext)(e);
    }
  };

  useEffect(() => {
    carouselContext.setStoreState({ disableKeyboard: true });
    window.addEventListener?.('keyup', handler);
    return () => {
      window.removeEventListener?.('keyup', handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
